const formatUrl = (str) => {
  if (!str?.includes("https")) return `https://${str}`;
};

export default formatUrl;
